import config from './config';
import instance from './apiInstance';

const VENDAS_SHORT = 'https://linktw.in/XXvhRB';
const VENDAS_TG = 'https://t.me/suapersonalshopper';

/** CTA genérico — LinkTwin (sem peça). */
export function getVendasUrl() {
  return config.TELEGRAM_VENDAS_URL || VENDAS_SHORT;
}

/** URL direta no Telegram com token da peça (bypass LinkTwin). */
export function buildTelegramBuyUrl(token) {
  const text = `Eu quero comprar amiga · b:${token}`;
  return `${VENDAS_TG}?text=${encodeURIComponent(text)}`;
}

/** Registra peça clicada antes de abrir o bot. */
export async function registerBuyIntent(piece = {}) {
  const image = piece.image_url || piece.url || piece.photo || '';
  const res = await instance.post(
    '/tg/buy-intent',
    {
      brand: piece.brand || '',
      title: piece.title || '',
      image_url: image,
      price: piece.price ?? null,
      product_id: piece.productId || piece.id || null,
      surface: piece.surface || null,
    },
    { headers: { noToken: true } },
  );
  return res.data;
}

/** Pedido fechado no app → canal oficial. Ela envia; vendas confirma a lista. */
export function getFecharPedidoUrl({ orderId, totalLabel, items } = {}) {
  const lines = ['Quero comprar esses pedidos — enviei pelo app', '']
  const rows = Array.isArray(items) ? items.filter(Boolean).slice(0, 12) : []
  if (rows.length) {
    rows.forEach((row) => lines.push(`• ${row}`))
    if (Array.isArray(items) && items.length > 12) {
      lines.push(`• e mais ${items.length - 12}`)
    }
  }
  lines.push('')
  if (totalLabel) lines.push(`Total: ${totalLabel}`)
  if (orderId) lines.push(`Pedido ${orderId}`)
  const text = lines.join('\n').slice(0, 1800)
  return `${VENDAS_TG}?text=${encodeURIComponent(text)}`
}

function openHref(href) {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null;
  if (tg?.openTelegramLink && String(href).includes('t.me/')) {
    tg.openTelegramLink(href);
    return;
  }
  if (tg?.openLink) {
    tg.openLink(href);
    return;
  }
  window.open(href, '_blank', 'noopener,noreferrer');
}

export async function openTelegramVendas(url, piece) {
  const hasPiece = piece && typeof piece === 'object' && (
    piece.url || piece.image_url || piece.photo || piece.title || piece.brand || piece.id || piece.productId
  );

  if (hasPiece) {
    import('./trackerBus').then(({ trackPiece }) => {
      trackPiece('cta_vendas_clicked', { button: 'buy', ...piece });
    }).catch(() => {});
  }

  let href = url || getVendasUrl();

  if (hasPiece) {
    try {
      const data = await registerBuyIntent(piece);
      if (data?.ok && data.token) {
        href = data.telegramUrl || buildTelegramBuyUrl(data.token);
      }
    } catch {
      /* fallback: abre CTA genérico */
    }
  }

  openHref(href);
}

export function openVendas() {
  openTelegramVendas(getVendasUrl());
}

/** Alias para os botões de depoimento da roleta (mesmo short). */
export function getTestimonialWhatsAppUrl(_prizeLabel) {
  return getVendasUrl();
}

export function openTestimonialWhatsApp(_prizeLabel) {
  openVendas();
}
